import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getRootBasedUrl } from '@resolve-js/core';
import isomorphicFetch from 'isomorphic-fetch';
import qs from 'query-string';
import { isString } from './utils';
import determineOrigin from './determine-origin';
import { GenericError } from './errors';
import { requestWithMiddleware } from './middleware';
export var VALIDATED_RESULT = Symbol('VALIDATED_RESULT');
var cachedFetch = null;

var determineFetch = function determineFetch(context) {
  if (context.fetch) {
    return context.fetch;
  }

  if (!cachedFetch) {
    cachedFetch = typeof fetch === 'function' ? fetch : isomorphicFetch;
  }

  return cachedFetch;
};

var stringifyUrl = function stringifyUrl(url, params, options) {
  if (options === void 0) {
    options = {};
  }

  if (params) {
    if (isString(params)) {
      return url + "?" + params;
    }

    return url + "?" + qs.stringify(params, Object.assign({
      arrayFormat: 'bracket'
    }, options));
  }

  return url;
};

export var request = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, url, requestParams, options, deserializer) {
    var _options$method, _response;

    var origin, rootPath, jwtProvider, rootBasedUrl, headers, requestUrl, init, response, middlewareResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            origin = context.origin, rootPath = context.rootPath, jwtProvider = context.jwtProvider;
            rootBasedUrl = getRootBasedUrl(rootPath, url, determineOrigin(origin));
            headers = {};
            _context.t0 = (_options$method = options == null ? void 0 : options.method) !== null && _options$method !== void 0 ? _options$method : 'POST';
            _context.next = _context.t0 === 'GET' ? 6 : _context.t0 === 'POST' ? 9 : 13;
            break;

          case 6:
            init = {
              method: 'GET',
              credentials: 'same-origin'
            };
            requestUrl = stringifyUrl(rootBasedUrl, requestParams, options == null ? void 0 : options.queryStringOptions);
            return _context.abrupt("break", 14);

          case 9:
            init = {
              method: 'POST',
              credentials: 'same-origin',
              body: typeof requestParams === 'string' ? requestParams : JSON.stringify(requestParams)
            };
            headers['Content-Type'] = 'application/json';
            requestUrl = rootBasedUrl;
            return _context.abrupt("break", 14);

          case 13:
            throw new GenericError("unsupported request method");

          case 14:
            init.headers = headers;
            _context.next = 17;
            return requestWithMiddleware({
              fetch: determineFetch(context),
              info: requestUrl,
              init: init,
              jwtProvider: jwtProvider,
              deserializer: deserializer
            }, options == null ? void 0 : options.middleware);

          case 17:
            middlewareResponse = _context.sent;

            if (!(middlewareResponse instanceof Error)) {
              _context.next = 20;
              break;
            }

            throw middlewareResponse;

          case 20:
            response = (_response = {
              ok: !(middlewareResponse.result instanceof Error),
              headers: middlewareResponse.headers
            }, _response[VALIDATED_RESULT] = middlewareResponse.result, _response.json = function json() {
              return Promise.resolve(middlewareResponse.result);
            }, _response.text = function text() {
              return Promise.resolve(middlewareResponse.result);
            }, _response);
            return _context.abrupt("return", response);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function request(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
//# sourceMappingURL=request.js.map